import { render, staticRenderFns } from "./chatAccount.vue?vue&type=template&id=3274b436"
import script from "./chatAccount.vue?vue&type=script&lang=js"
export * from "./chatAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports